import { render } from "./Prohibido.vue?vue&type=template&id=73117ee3"
const script = {}

import "./Prohibido.vue?vue&type=style&index=0&id=73117ee3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__